<template>
  <div style="max-width: 50rem; display: inline-block; width: 100%;margin-top: 2.5rem">
    <div style="height: auto;padding-left: 1rem;padding-right: 1rem;">
    </div>
    <div id="waline-comment"></div>
  </div>
</template>
